import config from '@vyce/core/src/api/config';

import { HelpAndContact } from '.';

export const EmployerHelp = () => {
  return <HelpAndContact faqUrl={config.employerFaqUrl} />;
};
